import { useEffect, useState } from "react";
import type { PDFDocumentProxy } from "pdfjs-dist";

export type PdfTextItem = {
  text: string;
  rect: { x: number; y: number; w: number; h: number };
};

export type PdfTextPage = {
  pageNumber: number;
  items: PdfTextItem[];
  fullText: string;
};

export function usePdfTextIndex(pdf: PDFDocumentProxy | null) {
  const [pages, setPages] = useState<PdfTextPage[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pdf) return;

    let cancelled = false;

    async function extract() {
      setLoading(true);
      const result: PdfTextPage[] = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const textContent = await page.getTextContent();
        const viewport = page.getViewport({ scale: 1 });

        const items: PdfTextItem[] = [];

        for (const item of textContent.items as any[]) {
          if (!item.str?.trim()) continue;

          const tx = item.transform;
          const x = tx[4];
          const y = viewport.height - tx[5] - (item.height || 12);
          const w = item.width || 0;
          const h = item.height || 12;

          items.push({
            text: item.str,
            rect: { x, y, w, h },
          });
        }

        result.push({
          pageNumber: i,
          items,
          fullText: items.map((i) => i.text).join(" "),
        });
      }

      if (!cancelled) {
        setPages(result);
        setLoading(false);
      }
    }

    extract();
    return () => {
      cancelled = true;
    };
  }, [pdf]);

  return { pages, loading };
}
